var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.55,149.27a12.16,12.16,0,1,1-12.15-12.1A12.13,12.13,0,0,1,120.55,149.27Zm67.57-51.59A12.16,12.16,0,1,1,176,85.59,12.13,12.13,0,0,1,188.12,97.68Zm-135.5,0A12.16,12.16,0,1,1,40.46,85.59,12.13,12.13,0,0,1,52.62,97.68Zm33.25.54h43.79M85.87,136.65h43.79M49.58,137l11.6-13.32h94.25L167,137m8.71-38.83-20.31,13.22H61.18L41,98.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.75,149.5a2.36,2.36,0,1,1-2.36-2.36,2.36,2.36,0,0,1,2.36,2.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.4,72.3h28.24M175.53,84.87V72.64M26.6,72.3H54.85M40.73,84.87V72.64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrone);
export default __webpack_public_path__ + "static/media/DRONE.f32bac4a8a91e0cdfa12119fdaf5c4f8.svg";
export { ForwardRef as ReactComponent };